import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=3f5875a0&scoped=true&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=3f5875a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5875a0",
  null
  
)

export default component.exports